import { render } from "./tncDelete-modal.vue?vue&type=template&id=3fdddb14"
import script from "./tncDelete-modal.vue?vue&type=script&lang=js"
export * from "./tncDelete-modal.vue?vue&type=script&lang=js"

import "./tncDelete-modal.vue?vue&type=style&index=0&id=3fdddb14&lang=css"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__